<div class="me-appointment-booking-page" *ngIf="data">
    <div class="container">
        <div class="me-appointment-booking-page--back_btn">
            <a class="btn btn-link btn-icon btn-icon--left btn-back btn--secondary " [routerLink]="['/me/appointment']">
                {{ 'back' | translate }}
            </a>
        </div>
    
        <div *ngIf="!showCalendar">
            <div tabindex="0" class="me-appointment-booking-page--body">
                <div class="me-appointment-booking-page--body--title">
                    {{data.consentTitle}}
                </div>
                <div class="me-appointment-booking-page--body--text" [innerHTML]="data.consentText | storyblokRichtext"></div>
            </div>
        
            <div tabindex="0" class="me-appointment-booking-page--confirm">
                <div class="me-appointment-booking-page--confirm--header" [innerHTML]="data.termsText | storyblokRichtext"></div>
                <div class="me-appointment-booking-page--confirm--checkbox" tabindex="0" role="checkbox" (keyup.enter)="isAgree = !isAgree">
                    <input tabindex="-1" type="checkbox" id="confirm-booking" [(ngModel)]="isAgree"/>
                    <label class="me-appointment-booking-page--confirm--link" for="confirm-booking" [innerHTML]="data.termsCheckboxLabel | storyblokRichtext"></label>
                </div>
                <div class="me-appointment-booking-page--confirm--btn pull-right">
                    <button [class.disabled]="!isAgree" [attr.tabindex]="!isAgree ? -1 : 0" class="btn btn--primary" (click)="confirm()" (keyup.enter)="confirm()">
                        {{ 'Next' | translate }}
                    </button>
                </div>
            </div>
        </div>
    
    
        <div *ngIf="showCalendar">
            <div class="me-appointment-booking-page--calendar">
                <div class="me-appointment-booking-page--calendar--title">
                    <div>
                        {{ data['bookingTitle']}}
                    </div>
                    <div class="me-appointment-booking-page--calendar--title--language" *ngIf="this.languages.length > 1">
                        <select class="me-custom-select--select" [(ngModel)]="language" (change)="updateCituroLink()">
                            <option class="me-custom-select--option" *ngFor="let language of languages" [ngValue]="language.id">
                                {{ language.name | translate }}
                            </option>
                        </select>
                        <i class="me-custom-select--dropdown fas fa-chevron-down"></i>
                    </div>
                </div>
                <div class="me-appointment-booking-page--calendar--text" [innerHTML]="data.bookingText | storyblokRichtext">
                </div>

                <hr/>

                <div class="me-appointment-booking-page--calendar--therapist" *ngIf="therapistData && therapistData['image']">
                    <div class="me-appointment-booking-page--calendar--therapist--icon">
                        <img src="{{therapistData['image']['filename']}}">
                    </div>
                    <div class="me-appointment-booking-page--calendar--therapist--info">
                        <div class="me-appointment-booking-page--calendar--therapist--info--name">
                            {{therapistData['title']}}
                        </div>
                        <div class="me-appointment-booking-page--calendar--therapist--info--title">
                            {{therapistData['title']}}
                        </div>
                    </div>
                </div>

                <iframe class="booking-iframe" [src]="bookingUrl" *ngIf="bookingUrl">
                </iframe>
            </div>
        </div>
    </div>
</div>

<dialog-component #dialog></dialog-component>
